<template>
    <div>
        <!-- <Input search enter-button="查询" @on-search="pNextSearch" placeholder="请输入文件名关键字..." /> -->
        <div v-if="rootfolderid==='' || rootfolderid==='001'"><img id="bground" style="display:block;width:500px;height: 500px;margin:5% auto;" src="../../assets/images/cloud/img-default.png" /></div>
        <div v-show="rootfolderid !=='001' &&  rootfolderid !==''">
            <SearchBar ref="cloudSearchBar" :isHidden="true" :src="true" @next-search="nextSearch"></SearchBar>
            <div class="demo-spin-container">
                <ResultTable ref="cloudFiles" @onPageChange="pageChange" :orderTypeId="3" :tData="rData" @selectUpload-checked="tableRowChecked" :noDataText="noDatatTxt"></ResultTable>
                <div v-if="flag">
                    <ResultTag ref="cloudResultTag" :key="rid" :isShowDeleteButton="true" :isShowupLoadGroup="isShowTagUpload" :sTreeData="tagData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isCloudNew=true @onTagchanged="childTagChange" @on-show-checkbox="showChkBox" @clean-checked="clearCheckList" @on-submit-checked="onGeneralSubmitChecked" @on-delete-checked="onCheckDeleteFilesSubmit" @on-submit-checked-cancel="onCheckedCancel" @on-tips-close="tagGeneralTipsClose" @on-onekey-delete="onekeyDeleteFolderFiles" @on-delete-abolitionfiles="deleteAbolition" @set-tagpc="layerChange"></ResultTag>
                </div>
                <!--  <Table :data="tableData1" :columns="tableColumns1" size="small" stripe></Table>
      <Row>
        <br />
        <Col span="2">
        </Col>
      </Row>
      <br>
      <Row>
        <Col span="24">
        <Page :total="pageTotal" :current="PageIndex" @on-change="changePage"></Page>
        </Col>
      </Row> -->
                <!--   <p style="line-height: 40px;">检索结果分类筛选:</p> -->
                <!--  <Row>
        <Col span="16">
        <div style="float: left">
          <TreeTag :tData="sTreeData" ref="firstTag" class="common-width" @tag-Select="tagSelect" @onTagChange="onTagChange"></TreeTag>
        </div>
        <div style="float: left;padding-left: 10px;">
          <TreeTag :tData="sTreeIndustry" ref="nextTag" @tag-Select="nextTagSelect" :style="{display:tag2Disp?'block':'none'}" class="common-width" @onTagChange="onTagChange"></TreeTag>
        </div>
        <div style="float: left;padding-left: 10px;">
          <TreeTag :tData="sTreeIndustry" ref="thirdTag" @tag-Select="thirdTagSelect" :style="{display:tag3Disp?'block':'none'}" class="common-width" @onTagChange="onTagChange"></TreeTag>
        </div>
        <div style="float: left;padding-left: 10px;">
          <Button type="primary" @click="reset">返回</Button>
        </div>
        </Col>
        <Col span="4">
        </Col>
      </Row> -->
                <Spin fix v-if="spinShow1"></Spin>
            </div>
        </div>
    </div>
</template>
<script>
//import cloudData from '../../../static/api/cloudData.json'
import testData2 from '../../assets/json/testTableData2.json'
import SelectData from '../../assets/json/selectData.json'
import expandRow from './content_main_list_expandtable.vue'
import TreeTag from '../common/tree-single-select.vue'
// import nextSearchBar from '../common/common_engine/nextSearchBar.vue'
import nextSearchBar from '../common/common_engine/nextSearchBar2.vue'
import resultTable from '../common/common_engine/resulttable.vue'
import ResultTag from '../common/common_engine/resultTag.vue'
import treeIndustryData from '../../assets/json/selected-tree-industry.json'
import treeTradeData from '../../assets/json/selected-tree-trade.json'
import TagCityData from '../../assets/json/tagCity.json'
import store from '../../store'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import constJson from '../../api/common/constjson.js'
import More from "../../api/common/more.js"
import eventBus from '../../components/common/event_bus.js'
let MoreFun = new More()
let constJ = new constJson()
export default {
    name: "CloudList",
    data() {
        return {
            noDatatTxt: '当前文件夹下没有您要检索的文件',
            classid: '',
            rid: +new Date(),
            rootfolderid: "",
            formItem: {
                time: [],
                text: '',
                fileforce: {}
                //industryselected: [],
            },
            tagList: SelectData.industry,
            rData: {},
            tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
            tableColumns1: [],
            spinShow1: false,
            //sTreeData: this.getTreeData(),
            // sTreeIndustry: this.getIndustryData(),
            showHeaders: [],
            // showfilename:false,
            sliders: this.getSliders(),
            //isExpand: this.isLeftExpand,

            pageTotal: 10,
            PageIndex: 1,
            PageSize: 10,
            tempData: {},

            flag: false, //绑定后设为true
            tagData: {},
            sTreeIndustry: this.getIndustryData(0),
            streeProvince: this.getProvince(),
            currentNode: {},
            isShowTagUpload: false,
            folderid: "",
            tagpc: [],
            isFirstSearch: true,
            isFilter: false,
        }
    },
    inject: ['CreatePage', 'getSliders', 'getclassid'],
    mounted() {
        //捕获云端树点击事件
        eventBus.$on('cloud-tree-select', () => {
            console.log('cloud-tree-select=====>')
            this.isFilter = false
            if (this.folderid === '001' || this.folderid === '' || this.folderid === undefined) {
                this.$Message.warning('请选择您要查看的文件夹')
                return
            } else {
                this.getNextSearchParm()
                this.getUserCloudFiles(1, this.currentNode.id, this.formItem)
            }

        })
    },
    beforeDestroy() {
        eventBus.$off('cloud-tree-select')
    },
    methods: {
        getNextSearchParm() {
            if (this.$refs.cloudSearchBar) {
                let v = this.$refs.cloudSearchBar.getSearchCondition()
                this.formItem.text = v.text
                this.formItem.time = v.time
                this.formItem.fileforce = v.fileforce
            }

        },
        searchReset() {
            this.tagpc = []
            this.isFilter = false
            this.currentNode = {}
        },
        layerChange(value) {
            this.tagpc = value
            this.isFilter = true
            let condition = this.$refs.cloudSearchBar.getNextCondition()
            if (condition) {
                this.formItem.text = condition.text
                this.formItem.time = condition.time
                this.formItem.fileforce = condition.fileforce
            }
            this.getUserCloudFiles(1, this.currentNode.id, this.formItem)
            //this.nextSearch()
        },
        setClassId(value) {
            this.classid = value
        },
        setFolderId(value) {
            this.folderid = value
        },
        getIndustryData(node) {
            if (node === 0) {
                node = { "data": [{ "label": "进出口税收管理类", "id": "001" }] }
            }
            return node
        },
        getProvince() {
            return TagCityData
        },
        childTagChange(node) {
            this.isFilter = true
            this.currentNode = node
            this.tagpc = this.$refs.cloudResultTag.getLayerData()
            this.getUserCloudFiles(1, node.id, this.formItem)
        },
        showChkBox(value) {
            this.$refs.cloudFiles.showCheckBox(value)
        },
        clearCheckList() {
            this.$refs.cloudFiles.clearChkList()
        },
        onGeneralSubmitChecked() {
            //提交General数据用户已选择的文件
            let count = this.$refs.cloudFiles.showListTotal()
            this.$Message.success("提交成功(" + count + ")")
            this.clearCheckList()
        },

        showDialog(title, content, total) {
            let that = this
            this.$Modal.confirm({
                title: title,
                //content: '<p>' + content + '</p>',
                render: h => {
                    return h('span', [
                        '您确定删除此文件夹下的',
                        h('span', {
                            domProps: {
                                innerHTML: ``,
                            }
                        }), '所有文件吗?'
                    ])
                },
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    //that.deleterow(row)
                    that.deleteFolderfiles()
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },

        showDialog2(title, content, total) {
            let that = this
            this.$Modal.confirm({
                title: title,
                //content: '<p>' + content + '</p>',
                render: h => {
                    return h('span', [
                        '您确定删除此文件夹下的',
                        h('span', {
                            domProps: {
                                innerHTML: ``,
                            }
                        }), '所有全文废止(失效)文件吗?'
                    ])
                },
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    //that.deleterow(row)
                    that.deleteAbolitionFolderFiles()
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },

        deleteFolderfiles() {
            this.deleteUerCloudFilesByFolder(this.folderid)
            this.clearCheckList()
        },

        deleteAbolition() {
            console.log("一键删除全文废止失效文件")
            let count = this.$refs.cloudFiles.tempData.total
            //console.log(count)
            if (this.folderid === "001" || this.folderid === "") {
                this.$Message.warning("请先选择文件夹,再执行一键删除")
                return
            } else {
                if (count > 0) {
                    this.showDialog2("提示", "")
                } else {
                    this.$Message.warning("当前文件夹下无全文废止(失效)文件")
                    return
                }

            }
        },
        deleteAbolitionFolderFiles() {
            this.deleteUerCloudAbolitionFilesByFolder(this.folderid)
        },
        onekeyDeleteFolderFiles() {
            console.log("一键删除")
            let count = this.$refs.cloudFiles.tempData.total
            console.log(count)
            if (this.folderid === "001" || this.folderid === "") {
                this.$Message.warning("请先选择文件夹,再执行一键删除")
                return
            } else {
                if (count > 0) {
                    this.showDialog("提示", "")
                } else {
                    this.$Message.warning("当前文件夹下无文件")
                    return
                }

            }

        },
        onCheckDeleteFilesSubmit() {
            let count = this.$refs.cloudFiles.showListTotal()
            let list = this.$refs.cloudFiles.getDocIdChecked()
            if (count > 0) {
                //按文件夹id和文件列表删除文件
                this.deleteUerCloudFilesByFolderAndList(this.folderid, list, count)
                this.clearCheckList()
            }


        },
        onCheckedCancel() {
            this.clearCheckList()
        },
        tagGeneralTipsClose() {
            this.$refs.cloudResultTag.tipClose()
        },

        ////2019.08.21
        // mockTableData1(tabrows) {
        //   let da = [];
        //   let items = tabrows
        //   for (var i = 0; i < items.length; i++) {
        //     // let expand = true;
        //     // if (items[i].forcecount > 0) {
        //     //   expand = false; //启用
        //     // }
        //     da.push({
        //       docid: items[i].docid,
        //       h1: items[i].h1,
        //       h2: items[i].h2,
        //       lastchangeeffectdate: items[i].lastchangeeffectdate,
        //       lastchangeeffectstate: items[i].lastchangeeffectstate,
        //       uploadtime: items[i].updatetime,
        //       seqid: items[i].seqid,
        //     })
        //   }
        //   //console.log(da)
        //   return da;
        // },



        // mockTableHeader(obj) {
        //   let da = [];
        //   let items = cloudData.header;
        //   let newHeaders = [];
        //   let offset = 0;
        //   //判断是否展开或收缩左侧目录
        //   if (this.getLeftExpand === undefined) {
        //     offset = 0
        //   } else if (!this.getLeftExpand) {
        //     offset = 28;
        //   }
        //   //console.log("offset1："+offset)
        //   this.setHeader(obj);
        //   for (var i = 0; i < items.length; i++) {
        //     if (this.showHeaders.indexOf(items[i].key) >= 0) {
        //       newHeaders.push(items[i])
        //     }
        //   }
        //   // console.log(newHeaders)
        //   items = newHeaders;
        //   for (var i = 0; i < items.length; i++) {
        //     let w = parseInt(items[i].width) + offset

        //     if (items[i].key == "h1") {
        //       // console.log(w)
        //       da.push({
        //         title: items[i].title,
        //         key: items[i].key,
        //         //width:630, //w + "px",
        //         align: items[i].align,
        //         render: (h, params) => {
        //           const row = params.row;
        //           const text = row.h1;
        //           const fileid = row.docid;
        //           return h('a', {
        //             on: {
        //               'click': () => {
        //                 this.add(fileid, 1, text);
        //                 // this.showfilename=true;
        //               }
        //             }
        //           }, text);
        //         }
        //       })

        //     } else {
        //       da.push({
        //         title: items[i].title,
        //         key: items[i].key,
        //         //width: w + "px",
        //         align: items[i].align,
        //       })
        //     }

        //   }
        //   //展开表格
        //   // da.push({
        //   //   type: 'expand',
        //   //   align: "left",
        //   //   width: 50,
        //   //   className: "expandclass",
        //   //   render: (h, params) => {
        //   //     // const row = params.row;
        //   //     return h(expandRow, {
        //   //       style: {
        //   //         border:'1px solid #dcdee2',
        //   //         borderBottom:'none',
        //   //         borderRight:'none'
        //   //         // height: '48px',
        //   //         // width: '141px',
        //   //         //color:'red',
        //   //       },
        //   //       props: {
        //   //         row: params.row,
        //   //         from:"uploadlibrary"
        //   //       }
        //   //     })
        //   //   }
        //   // })
        //   //console.log(da)
        //   return da;
        // },

        ////2019.08.21
        // mockTableHeader(header, headerTitle) {
        //   if (header !== null) {
        //     this.tempHeader = header
        //   }
        //   let da = [];
        //   let items = this.tempHeader //this.tData.header;
        //   let newHeaders = [];
        //   this.setHeader(headerTitle);
        //   //console.log(this.showHeaders)
        //   for (var i = 0; i < items.length; i++) {
        //     if (this.showHeaders.indexOf(items[i].key) >= 0) {
        //       newHeaders.push(items[i])
        //     }
        //   }
        //   //console.log("newHeaders:"+newHeaders.length)
        //   //console.log(newHeaders)
        //   items = newHeaders;
        //   for (var i = 0; i < items.length; i++) {
        //     if (items[i].key == "h1") {
        //       da.push({
        //         title: items[i].title,
        //         key: items[i].key,
        //         //width: 700,//w+"px",//700,//items[i].width,
        //         align: items[i].align,
        //         render: (h, params) => {
        //           const row = params.row;
        //           const text = row.h1;
        //           const fileid = row.docid;
        //           return h('a', {
        //             on: {
        //               'click': () => {
        //                 this.add(fileid, 1, text);
        //                 // this.showfilename=true;
        //               }
        //             }
        //           }, text);
        //         }
        //       })

        //     } else {
        //       da.push({
        //         title: items[i].title,
        //         key: items[i].key,
        //         //width: w+"px",//items[i].width,
        //         align: items[i].align
        //       })
        //     }

        //   }
        //   return da;
        // },


        ////2019.08.21
        // setHeader(arrayObj) {
        //   if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
        //     this.showHeaders = ['docid', 'lastchangeeffectdate', 'h1', 'h2', 'uploadtime', 'lastchangeeffectstate']
        //   } else {
        //     this.showHeaders = arrayObj
        //   }

        // },

        deleteUerCloudFilesByFolderAndList(folderid, list, c) {
            constJ.reqRemoveFilesByList(folderid, list).then(res => {
                console.log("reqRemoveFilesByList....")
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("删除成功(" + c + ")")
                        //重载table
                        this.getUserCloudFiles(this.PageIndex, this.currentNode.id, this.formItem)
                    } else {
                        console.log(res.rltdesc)
                        this.$Message.success("删除失败(" + res.rltdesc + ")")
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Message.success("删除失败(" + res.rtndesc + ")")
                }
            })
        },

        deleteUerCloudFilesByFolder(folderid) {
            constJ.reqRemoveFilesByFolderId(folderid).then(res => {
                console.log("reqRemoveFilesByFolder....")
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("删除成功")
                        //重载table
                        this.getUserCloudFiles(this.PageIndex)
                    } else {
                        console.log(res.rltdesc)
                        this.$Message.success("删除失败(" + res.rltdesc + ")")
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Message.success("删除失败(" + res.rtndesc + ")")
                }
            })
        },
        //删除指定文件夹下全文废止(失效)文件
        deleteUerCloudAbolitionFilesByFolder(folderid) {
            constJ.reqRemoveAbolitionFilesByFolderId(folderid).then(res => {
                console.log("reqRemoveAbolitionFilesByFolderId....")
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("删除成功")
                        //重载table
                        this.getUserCloudFiles(this.PageIndex, this.currentNode.id, this.formItem)
                    } else {
                        console.log(res.rltdesc)
                        this.$Message.success("删除失败(" + res.rltdesc + ")")
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Message.success("删除失败(" + res.rtndesc + ")")
                }
            })
        },


        getUserCloudFiles(index, tagid, args) {
            // this.$Loading.start();
            // console.log(index)
            // console.log(tagid)
            console.log(args)
            console.log("getUserCloudFiles:" + this.folderid)
            //resulttag组件还原,重置上一次残余数据
            this.rid = +new Date()

            this.rootfolderid = this.folderid
            let currentIndex = index
            var item = {}
            item.text2 = args === undefined ? "" : args.text //args.content
            item.stime = args === undefined ? "" : args.time[0] //args.da[0]
            item.etime = args === undefined ? "" : args.time[1] //args.da[1]
            item.potence = args === undefined ? "" : args.fileforce.id //args.content
            item.tagid = tagid === undefined ? "" : tagid
            item.tagpc = this.tagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            item.id = this.getclassid()
            //console.log(item)
            //为根节点时不请求接口
            // if (this.folderid === "001") {
            //   this.$emit('on-load-complete')
            //   return
            // }
            constJ.reqGetUploadFiles(this.PageSize, currentIndex, item, this.folderid).then(res => {
                console.log("reqGetUploadFiles....")
                console.log(res)
                //res= JSON.parse(JSON.stringify(res))
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: testData2.header,
                                //header: cloudData.header, //this.mockTableHeader(), //testData2.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                tabname: "cloudfiles",
                                tags: res.tbls[0].classifytag,
                                level: res.tbls[0].divisiontag,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                                showColumns: item.tagid.startsWith("000007000002") ? MoreFun.getColumns().treaty : [],
                                //source:'cloudlist'//暂时只有云端的数据会携带source属性
                            }
                        } else {
                            //默认
                            obj = {
                                header: testData2.header,
                                //header: cloudData.header, //testData2.header,
                                tabrows: null,
                                total: 0,
                                tabname: "cloudfiles",
                                tags: res.tbls[0].classifytag,
                                level: null,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                                showColumns: []
                                //showColumns: MoreFun.getColumns().uploadfile,
                                //source:'cloudlist',//暂时只有云端的数据会携带source属性
                            }
                        }
                    } else {
                        this.$Message.error(res.rltdesc)
                        return
                    }
                } else {

                }
                this.$refs.cloudFiles.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                // console.log("bind tag...")
                // console.log(_obj)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagData = tempTag
                this.flag = true
                //console.log(this.tagData)
                // this.$Loading.finish();
                this.$emit('on-load-complete',tempTag)
            }).catch(err => {
                console.log(err)
            })
        },


        // //2019.08.21
        // show(data) {
        //   //console.log(data)
        //   // this.classId=data.classid
        //   this.tableName = data.tabname === null ? '' : data.tabname
        //   this.pageTotal = data.total

        //   //this.tableData1 = this.mockTableData1(data.tabrows)
        //   this.rData=this.mockTableData1(data.tabrows)
        //   //在路由切换时存在已分屏的情况，在已分屏情况下需要判断是否处于分屏在渲染table的header
        //   if (this.sliders.length > 0) {
        //     this.tableColumns1 = this.mockTableHeader(data.header, ['h1'])
        //   } else {
        //     this.tableColumns1 = this.mockTableHeader(data.header, '')
        //   }

        //   this.$nextTick(() => {

        //   })

        // },

        // mockTableData1(tabrows) {
        //   let da = [];
        //   let items = tabrows //this.tData.tabrows
        //   //console.log(this.tData);
        //   //var items=JSON.parse(tabledata.tabrows);
        //   //var x=h('Tag', {props: {type: 'dot',color:red}}, "txt");
        //   //var len = items.length
        //   // let random = Math.floor(Math.random() * len)
        //   // if (random === 0) {
        //   //   random = 1
        //   // }
        //   for (var i = 0; i < items.length; i++) {
        //     da.push({
        //       docid: items[i].docid,
        //       fname: items[i].fname,
        //       fcode: items[i].fcode,
        //       pdate: items[i].pdate,
        //       publisher: items[i].publisher,
        //       potence: items[i].potence,
        //     })
        //   }


        //   return da;
        // },
        // formatDate (date) {
        //     const y = date.getFullYear();
        //     let m = date.getMonth() + 1;
        //     m = m < 10 ? '0' + m : m;
        //     let d = date.getDate();
        //     d = d < 10 ? ('0' + d) : d;
        //     return y + '-' + m + '-' + d;
        // },
        pageChange(index, tabName) {
            this.changePage(index)
        },
        changePage(index) {
            // console.log("changepage...")
            // console.log(this.currentNode.id)
            // console.log(this.formItem)
            this.getUserCloudFiles(index, this.currentNode.id, this.formItem)
            this.PageIndex = index
        },

        // add(fid, orderid, filename) {
        //   this.CreatePage(fid, orderid, filename);
        // },

        // reloadHeaderData(obj) {
        //   this.tableColumns1 = this.mockTableHeader(obj);
        // },

        // pNextSearch() {
        //   this.value1 = "1"
        //   this.spinShow1 = true
        //   var that = this
        //   setTimeout(function() {
        //     that.spinShow1 = false
        //   }, 1000)
        // },

        // getTreeData() {
        //   return treeTradeData
        // },
        // getIndustryData() {
        //   return treeIndustryData
        // },

        // reset() {
        //   if (this.tag3Disp) {
        //     this.tag3Disp = false
        //   } else {
        //     this.tag2Disp = false
        //   }
        //   this.$refs.firstTag.disabled = false
        //   this.$refs.nextTag.disabled = false
        //   this.$refs.thirdTag.disabled = false

        // },

        // getExpand() {
        //   return store.state.user.isLeftExpand
        // },
        //二次查询的时间参数是否为空
        //为空返回true,不为空返回false
        isTimeNullOrEmpty(value) {
            let rlt = false
            console.log(value)
            if (value.time.length === 0 && value.text === "") {
                rlt = true
            } else if (value.time.length === 2 && value.time[0] === "" && value.time[1] === "" && value.text === "") {
                rlt = true
            }
            console.log(rlt)
            return rlt
        },
        nextSearch(condition) {
            //console.log(condition)
            //第二次查询
            // if (this.isTimeNullOrEmpty(condition)) {
            //     this.isFirstSearch = true
            // } else {
            //     this.isFirstSearch = false
            // }

            this.isFilter = false
            this.currentNode = {}
            if (condition) {
                this.formItem.text = condition.text
                this.formItem.time = condition.time
                this.formItem.fileforce = condition.fileforce
            }

            // console.log(this.currentNode.id)
            // console.log(this.formItem)
            this.getUserCloudFiles(1, this.currentNode.id, this.formItem)

        },
        tableRowChecked(listCount) {
            this.$refs.cloudResultTag.showBtnTxt(listCount)

        },



    },
    computed: {
        ...mapGetters(['getLeftExpand'])
    },
    watch: {
        sliders: function(v) {
            //var id = this.$route.query.classid
            var tagid = this.currentNode.id === undefined ? "" : this.currentNode.id
            console.log('tagid:' + tagid)
            //多屏还原到单屏时判断id来动态显示或隐藏文号字段
            if (tagid.startsWith('000007000002')) {
                this.$refs.cloudFiles.onSlidersChanged(MoreFun.getColumns().treaty)
            } else {
                this.$refs.cloudFiles.onSlidersChanged()
            }

            //this.$refs.cloudFiles.show(this.tempData)
            //这里请求数据导致页面刷新时扭曲,替换为从临时数据中读取data
            //this.show(this.tempData)

            //this.getUserCloudFiles(this.PageIndex)


            // if (this.sliders.length == 0) {
            //   this.reloadHeaderData([]);
            // } else if (this.sliders.length > 0) {
            //   this.reloadHeaderData(['h1']);
            // }
        },
        getLeftExpand: function() {
            //this.getUserCloudFiles(this.PageIndex)

            //console.log(this.getLeftExpand)
            // if (this.sliders.length == 0) {
            //   this.reloadHeaderData([]);
            // } else if (this.sliders.length > 0) {
            //   this.reloadHeaderData(['h1']);
            // }
        }
    },
    //现存问题,子组件重复发送
    created: function() {
        console.log("created.......")
        store.state.user.initData.currentVersion = '3'
        console.log(this.rootfolderid)
        //console.log(this.rData)
        // if (store.state.user.userId !== undefined && store.state.user.userId.length > 1) {
        //   this.getUserCloudFiles(this.PageIndex)
        // } else {
        //   //重登录
        // }

    },
    components: {
        expandRow,
        'TreeTag': TreeTag,
        'SearchBar': nextSearchBar,
        'ResultTable': resultTable,
        'ResultTag': ResultTag,
    },
}
</script>
<style scoped>
.expandclass {
    background-color: white;
}

.demo-spin-container {
    display: inherit;
    width: auto;
    height: auto;
    position: relative;
    /* border: 1px solid #eee;*/
}

.common-width {
    width: 250px;
}
</style>
<style>
td.ivu-table-expanded-cell {
    padding: 10px 10px;
    background: white;
}
</style>